// extracted by mini-css-extract-plugin
export var addButton = "_bi-0";
export var border = "_bi-8";
export var check = "_bi-h";
export var danger = "_bi-6";
export var dropdownContainer = "_bi-1";
export var editModalBody = "_bi-j";
export var footerContainer = "_bi-i";
export var fullWidth = "_bi-a";
export var hide = "_bi-9";
export var icon = "_bi-3";
export var input = "_bi-7";
export var inputFlex = "_bi-b";
export var inputWrapper = "_bi-c";
export var manualFocus = "_bi-5";
export var optionButton = "_bi-4";
export var pillWrapper = "_bi-e";
export var pointer = "_bi-2";
export var showOverflow = "_bi-f";
export var tagsFlex = "_bi-d";
export var xButton = "_bi-g";